// extracted by mini-css-extract-plugin
export default {"container":"ThemeToggle_container__RIfhe","button":"ThemeToggle_button__Mq8tg"};